





































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Table } from '@/components/bwaff';
import userManagerApi, {impersonateMember, UserManagerApi} from '@/views/settings/multi-user-access/user-manager/api';
import workspacesApi, {WorkspacesApi} from '@/views/settings/multi-user-access/workspaces/api';
import moment from 'moment';

@Component({
  components: {
    DataTable: Table,
  }
})
export default class UserManagement extends Vue {
  @Prop({default:'DD MMM YYYY hh:mm'})
  format!: string;
  userManagerApi: UserManagerApi = userManagerApi;
  workspacesApi: WorkspacesApi = workspacesApi;
  allMembersNormalized:any = {};
  rows: any = [];
  rowsOnPage: number = 10;
  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };

  utcToLocal(date) {
    return moment(moment.utc(date).toDate()).local()
  }

  get memberLink() {
    const port = location.port ? `:${location.port}` : '';
    const routeParams = {
      name: 'login.member',
      query: {
        accountId: this.$store.state.user.id
      }
    };
    const path = this.$router.resolve(routeParams).href.replace(/^\//, '');

    return `${location.protocol}//${location.hostname}${port}/${path}`;
  }
  
  get tableRows() {
    if (!this.rows) return [];
    return this.rows.map((e: any) => {
      return {
        email: e.login,
        role: e.role,
        fullName: e.fullName,
        created: e.created,
        workspaces: e.workspaces || null,
        actions: '',
        canCreate: e.canCreate,
        id: e.id,
        accessToExistingItems: e.accessToExistingItems,
        status: e.status,
        loginUrl : e.loginUrl
      }
    });
  }

  get headers() {
    return [
      {
        text: this.t('Name'),
        value: 'fullName',
        sortable: false
      },
      {
        text: this.t('Email'),
        value: 'email',
        sortable: false
      },
      {
        text: this.t('Role'),
        value: 'role',
        sortable: false
      },
      {
        text: this.t('Private Workspaces'),
        value: 'workspaces',
        sortable: false
      },
      {
        text: this.t('Created at'),
        value: 'created',
        sortable: false
      },
      {
        value: 'actions',
        sortable: false
      },
    ]
  }

  deleteUser(id: string) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
      onConfirm: () => {
        this.userManagerApi.delete(id)
          .then(async () => {
            await this.workspacesApi.getWorkspaces();
            return this.userManagerApi.getMembers();
          })
          .then((data: any) => this.rows = data)
          .finally(() => this.bus.emit('toast-success', this.t('User successfully deleted.')));
      },
    }})
  }

  createMember(id?: any) {
    const user = this.allMembersNormalized[id] || null
    this.bus.emit('open-dialog', { name: 'CreateMember', data: { user } });
  }

  @Watch('userManagerApi.data')
  membersDataReceived() {
    if(!this.userManagerApi.data) return [];

    this.allMembersNormalized = {...this.userManagerApi.dataNormalized}
    return this.rows = this.userManagerApi.data;
  }

  showConfirmImpersonate(member: { id:string,email:string }) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('When logging in as another user or admin, you will be provided with the read-only access to settings of this member.<br> No editing in the member’s account allowed.<br> You can go back to your account by clicking <b>Return back</b> at the top of the page.'),
      confirmButtonText: this.t('Log In As Member'),
      confirmButtonIcon: 'fas fa-sign-in',
      onConfirm: () => {
        impersonateMember(member);

        this.$mixpanel?.track('settings_impersonate', {
          source:'table',
          owner_email: this.$store.state.user.email,
          member_email: member.email,
        });
      },
    }})
  }
}
